
export function findCenterTile(scene) {
    const finalHexagon = scene.hexagons[scene.hexagons.length - 1];
    const halfQ = Math.round(finalHexagon.tile.q / 2);
    const halfR = Math.round(finalHexagon.tile.r / 2);
    const foundTile = scene.hexagons.find(hex => hex.tile.q === halfQ && hex.tile.r === halfR);
    return foundTile.tile;
}

